import { Container } from 'react-bootstrap';
import ReceiveFormsMailModal from './ReceiveFormsMailModal';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';

const ReceiveFormsMailModalDemo = () => {
  const [show, handleShow, handleClose] = useModal();

  return (
    <Container>
      <Button onClick={handleShow}>Receive Forms Mail Modal</Button>
      <ReceiveFormsMailModal showModal={show} closeModal={handleClose} />
    </Container>
  );
};

export default ReceiveFormsMailModalDemo;
